export var createWrapSubscribeFunction = function createWrapSubscribeFunction(patch, toObserver) {
  var emptyFunction = function emptyFunction() {}; // tslint:disable-line:no-empty
  var isNextFunction = function isNextFunction(args) {
    return typeof args[0] === 'function';
  };
  return function (innerSubscribe) {
    var _subscribe = function subscribe() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var unsubscribe = innerSubscribe(isNextFunction(args) ? toObserver({
        next: args[0]
      }) : toObserver.apply(void 0, args));
      if (unsubscribe !== undefined) {
        return unsubscribe;
      }
      return emptyFunction;
    };
    _subscribe[Symbol.observable] = function () {
      return {
        subscribe: function subscribe() {
          return {
            unsubscribe: _subscribe.apply(void 0, arguments)
          };
        }
      };
    };
    return patch(_subscribe);
  };
};